export const HandleInputChange = (e, setState) => {
    let { id, value } = e.target;
    if(id === "pan_number") {
        value = value.toUpperCase();
    }
    if(value.trim() === '') {
        value = ''
    }
    setState((prevState) => ({ ...prevState, [id]: value }));
}